import {createContext} from 'react';

const DashBoardContext = createContext()

export default DashBoardContext;
